import { IBusinessConfigs } from '../_Common/Const/BusinessConfigs';
import { initConst } from '../../../Utils/utils';

const LABusinessConfig = initConst<IBusinessConfigs>(() => ({
  LAEnhet: {
    defaultColumns: [
      { attributeDef: 'ENHET', caption: 'Enhet' },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'ANTALDEC', caption: 'Antal decimaler' },
    ],
  },
  LAArtikel: {
    defaultColumns: [
      { attributeDef: 'ARTIKELNR', caption: 'Artikelnr' },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      // { attributeDef: 'PrislistaPris', caption: 'Pris enligt prislista' },
      { attributeDef: 'Artikelgrupp.ARTIKELGRUPP', caption: 'Artikelgrupp' },
      { attributeDef: 'Artikeltyp', caption: 'Artikeltyp' },
      { attributeDef: 'Forrattningstyp', caption: 'Förrättningstyp' },
      { attributeDef: 'SORTIMENT', caption: 'Sortiment' },
    ],
  },
  LAFakturatext: {
    defaultColumns: [
      { attributeDef: 'SORTKOD', caption: 'Standardtextnr' },
      { attributeDef: 'BenamningShort', caption: 'Benämning' },
    ],
  },
  LAPrislista: {
    defaultColumns: [
      { attributeDef: 'BENAMNING', caption: 'Prislista' },
      { attributeDef: 'KUNDLEVERANTOR', caption: 'Mot kund/leverantör' },
      { attributeDef: 'STANDARD', caption: 'Standard' },
    ],
  },
  LAArtikelgrupp: {
    defaultColumns: [
      { attributeDef: 'ARTIKELGRUPP', caption: 'Artikelgrupp' },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'FaktuGrupper', caption: 'Faktureringsgrupper' },
    ],
  },
}));

export default LABusinessConfig;
